<bs-freebet-stake *ngIf="freeBetToken; else stakeInput" [freeBetToken]="freeBetToken"></bs-freebet-stake>
<ng-template #stakeInput>
    <ms-stake
        [stake]="stakeAsStr"
        [errors]="hasStakeError$"
        [keypadId]="keypadId"
        [numpadSource]="numpadSource"
        [disabled]="isDisabled"
        [bsLinearStakeScroll]="'.betslip-edit-state__scroller'"
        (stakeChanged)="setStake($event)">
    </ms-stake>
</ng-template>
